var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',[_vm._v("\n    Welcome\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }